import React, { useState, useEffect, useCallback,useRef } from "react";
import DropDownButton from "devextreme-react/drop-down-button";
import data from "../../assets/apiRoutes.json";
import { connect } from "react-redux";
import "devextreme/data/odata/store";
import { GridLayout } from "../../common/GridLayout";
import { Localization } from "../../common/Localization";
import {
  Column,
  DataGrid,
  GroupPanel,
  SearchPanel,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Pager,
  LoadPanel,
  Export,
  ColumnHeaderFilter,
  ColumnChooser,
  ColumnFixing,
  StateStoring,
  Toolbar,
  Item
} from "devextreme-react/data-grid";
import axios from "axios";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
const SubLotExpressTable = (props) => {
  var accessToken = props.oidc.user.access_token;
  const [currentLayout, setCurrentLayout] = useState("Default");

  const [lotData, setLotData] = useState([]);
  const [loading, setLoading] = useState("Data Loading");
  const loadLotData = () => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.SubLot}?id=${props.id}&lotid=${props.lotid}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((res) => {
        setLotData(res.data);
        if (lotData && lotData.length == 0) setLoading("No Data Found");
      })
      .catch((err) => {
        console.log(err, "err in load sub lot");
        setLoading("No Data Found");
      });
  };
  const buttonDropDownOptions = { width: 140 };
  // tabs handling
  const [currentTab, setCurrentTab] = useState(1);
  const changeCurrentTab = (e) => {
    setCurrentTab(e.tab);
    var request = {
      value: e.itemData.tab,
      id: e.itemData.rowId,
      serialNumbRowid: e.itemData.serialNumbRowid,
      detailrowid: e.itemData.detailrowid,
      subdetailrowid: e.itemData.subdetailrowid,
      itemrowid: e.itemData.itemrowid,
      lotId: e.itemData.lotId,
      sublotrowid: e.itemData.sublotrowid,
    };
    props.changeTab(request);
  };
  useEffect(() => {
    loadLotData();
  }, []);
const dataGrid = useRef(null);
  const allowedPageSizes = [5, 10, 20, "all"];
  const gridKey = "026192ae-c593-42b7-a191-3531d33c2c96";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

  return (
    <div>
      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        ref={dataGrid}
        noDataText={loading}
        dataSource={lotData}
        showBorders={true}
        className={props?.SearchPanelAccordionStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
        hoverStateEnabled={true}
        allowColumnResizing={true}
        allowColumnReordering={true}
      >
        <Column dataField="rowid" caption="" cellRender={(rowid) => cellRender(rowid)} />
        <ColumnChooser enabled={true} />
        <ColumnFixing enabled={true} />
        <ColumnHeaderFilter visible={true} />
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting visible={true} mode="multiple" />
        <LoadPanel enabled={true} />
        <Paging defaultPageSize={10} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <HeaderFilter visible={true} />
        <GroupPanel visible={true} />
        <SearchPanel visible={true} />
        <Grouping autoExpandAll={false} />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Column dataField="sublotcode" caption={Localization.formatMessage('IMSUBLOT.SUBLOTCODE', 'Sublot')}></Column>
        <Column dataField="locationcode" caption={Localization.formatMessage('IMLOCATION.LOCATIONCODE', 'Location Code')}></Column>
        <Column dataField="itemcode" caption={Localization.formatMessage('IMITEM.ITEMCODE', 'Item')}></Column>
        <Column dataField="dateexpiration" dataType="date" caption={Localization.formatMessage('IMSUBLOT.DATEEXPIRATION', 'Date Expiration')}></Column>
        <Column dataField="grossweightuom" caption={Localization.formatMessage('IMSUBLOT.GROSSWEIGHTUOM', 'Gross Weight Unit UOM')}></Column>
        <Column dataField="quantityorder" caption={Localization.formatMessage('WMTRANSACTIONDETAIL.QUANTITYORDER', 'Quantity Order')}></Column>
        <Column dataField="quantityactual" caption={Localization.formatMessage('WMTRANSACTIONDETAIL.QUANTITYACTUAL', 'Quantity Actual')}></Column>
        <Column dataField="netweight" caption={Localization.formatMessage('IMSUBLOT.NETWEIGHT', 'Net Weight')}></Column>
        <Column dataField="grossweight" caption={Localization.formatMessage('IMSUBLOT.GROSSWEIGHT', 'Gross Weight')}></Column>
        <Toolbar>
          <Item location="after">
            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>
      </DataGrid>
    </div>
  );
  function cellRender(rowid) {
    return (
      <DropDownButton
        className="dropdownWithoutText"
        dropDownOptions={buttonDropDownOptions}
        items={[
          { name: "Lots", tab: 0, rowId: rowid.data.rTransactionheader },
          {
            name: "Serial Number",
            tab: 2,
            rowId: rowid.data.rowid,
            serialNumbRowid: rowid.data.rlot,
            detailrowid: rowid.data.rTransactiondetail,
            subdetailrowid: rowid.data.subdetailrowid,
            itemrowid: rowid.data.itemrowid,
            lotId: rowid.data.rlot,
            sublotrowid: rowid.data.rSublot
          },
        ]}
        displayExpr="name"
        onItemClick={(e) => changeCurrentTab(e)}
        // onSelectionChanged={(e) => changeCurrentTab(e)}
        keyExpr="rowId"
      />
    );
  }
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(SubLotExpressTable);
